import React, { Dispatch, SetStateAction } from "react";
import "./GameSplash.scss";
import video from "../../../../assets/video/background.mp4";
import { GameState } from "../GamePlayer";
import { PulseButton } from "../../../../components/PulseButton/PulseButton";
import { Trans, useTranslation } from "react-i18next";
import { Logo } from "../../../../components/Logo/Logo";

interface IProps {
    visible: boolean
    setGameState: Dispatch<SetStateAction<GameState>>
}

export function GameSplash({
                               visible,
                               setGameState
                           }: IProps) {
    const { t } = useTranslation();

    return (
        <div className={`game-splash-wrapper ${visible ? 'visible' : ''}`}>
            <div className="video-background">
                <video src={video} controls={false} muted={true} autoPlay={true} playsInline={true} loop={true}/>
            </div>
            <div className="overlay">
                <div className="logo-header">
                    <div className="logo-header-container">
                        <Logo />
                    </div>
                </div>
                <h1>ACE GAME</h1>
                <PulseButton onClick={() => setGameState('welcome')}>{t('generic.button-touch-me')}</PulseButton>
                <h2><Trans
                    i18nKey={"game.splash-subtitle"}
                /></h2>
            </div>
        </div>
    )
}
